import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import { getSettingsTopBlockParams } from '../SettingsContainer/functions';
import ExportTableAction from 'src/components/ExportTableAction';
import { ExportTypeType } from 'src/types/table';

type TopBlockProps = {
    reloadProviderCompaniesList: () => void;
    permissionCreate: boolean;
    handleExport: (type: ExportTypeType) => void;
    activeTab: string;
    setActiveTab: (value: string) => void;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate(`/settings/provider_companies/new`);
    };

    const params = getSettingsTopBlockParams();

    return (
        <>
            <BodyTopBlock
                tabs={params.tabs}
                selectTab={params.selected}
                onChangeTab={params.handleChange}
                actions={[
                    {
                        node: (
                            <ExportTableAction
                                title={translate('providerCompanies.action.exportFile')}
                                handleExport={props.handleExport}
                            />
                        ),
                    },
                    {
                        onClick: props.reloadProviderCompaniesList,
                        icon: <ReloadIcon />,
                        tooltip: translate('providerCompanies.action.synchronizeTable'),
                        variant: 'outlined',
                    },
                    {
                        label: translate('providerCompanies.action.createNew'),
                        onClick: handleNew,
                        icon: <AddIcon />,
                        hidden: !props.permissionCreate,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
